export default "__VITE_ASSET__a3d2mq32__"